export function average(arr) {
    return arr.reduce((a,b) => a + b, 0) / arr.length;
}

export function interpolateP(stochasticEconomicData, targetLoss) {
    if (!stochasticEconomicData.length) {
        return null; // Return null if the array is empty
    }

    // Sort the data by 'loss' in ascending order
    stochasticEconomicData.sort((a, b) => a.loss - b.loss);

    // Find the data points that surround the target 'loss'
    let lowerDataPoint = null;
    let upperDataPoint = null;

    for (let i = 0; i < stochasticEconomicData.length; i++) {
        if (stochasticEconomicData[i].loss <= targetLoss) {
            lowerDataPoint = stochasticEconomicData[i];
        } else {
            upperDataPoint = stochasticEconomicData[i];
            break;
        }
    }

    if (!upperDataPoint && lowerDataPoint) {
        return 1; // Return 1 if the target loss is greater than the maximum loss
    }

    if (!lowerDataPoint || !upperDataPoint) {
        return null; // Unable to interpolate, return null
    }

    // Perform linear interpolation
    const x0 = lowerDataPoint.loss;
    const x1 = upperDataPoint.loss;
    const y0 = lowerDataPoint.p;
    const y1 = upperDataPoint.p;

    const interpolatedP = y0 + ((y1 - y0) * (targetLoss - x0)) / (x1 - x0);
    return interpolatedP;
}


